import React, { forwardRef } from "react";
import TextInput from "../../text-input";
import { ChequeTypes, RefsCheque } from "../types/cheque.types";

export interface ChequeWithForwardRef
  extends React.ForwardRefExoticComponent<
    ChequeTypes & React.RefAttributes<() => RefsCheque>
  > {}

export const Cheque = forwardRef<() => RefsCheque, ChequeTypes>(
  (
    { nameInput, routingNumberInput, accountNumberInput }: ChequeTypes,
    ref
  ): React.ReactElement => {
    const { nameInputRef, routingNumberInputRef, accountNumberInputRef } =
      (ref as any)?.() || {};

    return (
      <>
        <TextInput {...nameInput} ref={nameInputRef} />
        <TextInput {...routingNumberInput} ref={routingNumberInputRef} />
        <TextInput {...accountNumberInput} ref={accountNumberInputRef} />
      </>
    );
  }
) as ChequeWithForwardRef;

Cheque.displayName = "Cheque";
